import { flatten } from 'lodash'

export default {
  allSectors: state => state.all,

  ticketsOpened: state =>
    flatten(state.all.map(sector => sector.tickets))
      .filter(ticket => ticket.isOpened),
}
